import React from 'react'
import { Link } from 'react-router-dom'

import { Svg, Icon } from '@components/shared/elements'

import './SearchBar.scss'

import { DebounceInput } from 'react-debounce-input'

import { isEmpty } from 'lodash'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
// actions
import * as PRODUCT_ACTION from '@store/products/actions'
import * as SHARED_ACTION from '@store/shared/actions'

class SearchBar extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      textField: '',
      showDataList: false,
      geolocationGranted: false,
      itemsToShow: [],
      limitItemsToShow: 5,
      loading: false,
    }
    this.el = React.createRef()
  }

  componentDidMount() {
    this._hasGrantedGeolocationPermission()
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.location.pathname !== prevProps.location.pathname ||
      this.props.location.hash !== prevProps.location.hash
    ) {
      this.setState({ textField: '', showDataList: false })
      this._searchTerm('')
    }
  }

  _handleChange(target) {
    const { value, tagName } = target

    const defineValue = tagName.toLowerCase() !== 'input' ? '' : value

    this.setState({
      loading: defineValue ? true : false,
      textField: defineValue,
    })

    this._searchTerm(defineValue)
  }

  _searchTerm(value) {
    this.setState({
      limitItemsToShow: 5,
    })
    this.props.actions.getItemsByTermFromSearchBar(value)
      .then(res => {
        const { imoveis, cidades, bairros } = this.props.searchItems

        this.setState((state) => ({
          itemsToShow: [...imoveis, ...cidades, ...bairros],
          loading: false,
        }))
      }).catch(error => {
        this.setState((state) => ({
          itemsToShow: [],
          loading: false,
        }))
      })
  }

  _toggleDataList(visible = false) {
    this.setState({
      showDataList: visible,
    })
  }

  _getCurrentPositionUsingGeolocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.setState({ geolocationGranted: true })
        },
        (error) => this.setState({ geolocationGranted: false })
      )
    }
  }

  _hasGrantedGeolocationPermission() {
    if ('permissions' in navigator && 'geolocation' in navigator) {
      navigator.permissions.query({ name: 'geolocation' })
        .then((result) => {
          this.setState({ geolocationGranted: result.state === 'granted' ? true : false })
        })
    } else {
      this._getCurrentPositionUsingGeolocation()
    }
  }

  _mountUrl(item) {
    const { tipo, url } = item
    // let redirectUrl = tipo === 3 ? url.split('/todos/')[0] : url

    return `/apartamento${tipo !== 1 ?  's' : ''}/${url}`
  }

  _updateSearchItems(item) {
    if (item.tipo !== 1) {
      let payload = { region: item.idEstado, city: item.idCidade, neighborhood: '' }
      if (item.tipo === 3) {
        payload = { ...payload, neighborhood: item.id }
      }
      this.props.actions.updateSearch(payload)
    }
  }

  render() {
    return (
      <div className={`search-bar${this.state.showDataList ? ' touched' : ''}`}>
        <button
          className='btn-search-back'
          disabled={!this.state.showDataList}
          onClick={(event) => {
            this._handleChange(event.target)
            this._toggleDataList()
          }}
        >
          {this.state.showDataList ?
            <Icon icon='arrow-left' size='sm' /> :
            <Icon icon='search' size='sm' />
          }
        </button>

        <DebounceInput
          className='no-shadow'
          type='search'
          placeholder='Procurar imóveis'
          value={this.state.textField}
          onChange={(event) => this._handleChange(event.target)}
          onFocus={(event) => {this._toggleDataList(true)}}
          debounceTimeout={500}
          inputRef={ref => {
            this.el = ref
          }}
        />

        <button onClick={(event) => {
          this._handleChange(event.target)
          this.el.focus()
        }}>
          <Icon icon='times' size='sm' />
        </button>

        <div className={`search-wrapper${this.state.showDataList ? ' search-wrapper--show' : ''}`}>
          {!this.state.geolocationGranted && (
            <p onClick={(event) => this._getCurrentPositionUsingGeolocation()}
              className='search-wrapper__clickable search-wrapper__location'>
              <Svg src={'/Files/vivaz.com.br/content/img/icons/target.svg'} />
              Usar minha localização
            </p>
          )}

          {!isEmpty(this.props.searchItems) && (
            <ul>
              {
                this.state.loading ? <li className='mt2 mb3'>Buscando...</li> :
                !isEmpty(this.state.itemsToShow) && this.state.itemsToShow.slice(0, this.state.limitItemsToShow).map(item => (
                  <li
                    key={item.id}
                    onClick={(event) => {
                      this._toggleDataList()
                      this._updateSearchItems(item)
                    }}
                  >
                    {+item.tipo === 1 ? (
                      <a className='search-wrapper__clickable' href={this._mountUrl(item)}>
                        <Svg src='/Files/vivaz.com.br/content/img/icons/building.svg' />
                        {item.titulo}
                      </a>
                      ) : (
                      <Link className='search-wrapper__clickable' to={this._mountUrl(item)}>
                        <Svg src='/Files/vivaz.com.br/content/img/icons/pin.svg' />
                        {item.titulo}
                      </Link>
                    )}
                  </li>
                ))
              }
            </ul>
          )}

          {
            this.state.itemsToShow.length > 5 &&
            this.state.limitItemsToShow === 5 &&
            !this.state.loading && (
            <p className='see-more'
             onClick={(event) => this.setState(() => ({ limitItemsToShow: this.state.itemsToShow.length })) }>
              <span>Ver mais resultados</span>
              <Icon icon='arrow-right' size='sm' />
            </p>
          )}

          <p className='search-wrapper__info'>Atuamos nos estados listados abaixo</p>
          <ul>
            <li onClick={(event) => {
              this._toggleDataList()
              this.props.actions.switchLocation(1)
            }}>
              <Link className='search-wrapper__clickable' to='/apartamentos/sao-paulo-sp'>
                <Svg src={'/Files/vivaz.com.br/content/img/icons/pin.svg'} />
                São Paulo
              </Link>
            </li>
            <li onClick={(event) => {
              this._toggleDataList()
              this.props.actions.switchLocation(22)
            }}>
              <Link className='search-wrapper__clickable' to='/apartamentos/rio-de-janeiro-rj'>
                <Svg src={'/Files/vivaz.com.br/content/img/icons/pin.svg'} />
                Rio de Janeiro
              </Link>
            </li>
            <li onClick={(event) => {
              this._toggleDataList()
              this.props.actions.switchLocation(24)
            }}>
              <Link className='search-wrapper__clickable' to='/apartamentos/porto-alegre-rs'>
                <Svg src={'/Files/vivaz.com.br/content/img/icons/pin.svg'} />
                Rio Grande do Sul
              </Link>
            </li>
          </ul>
        </div>

        <div className={`overlay${this.state.showDataList ? ' overlay--open' : ''}`}></div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    highlight: state.products.highlight,
    region: state.shared.region,
    searchItems: state.shared.searchItems,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({
      ...PRODUCT_ACTION,
      ...SHARED_ACTION,
    }, dispatch),
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(SearchBar)



// WEBPACK FOOTER //
// ./src/components/children/SearchBar/SearchBar.js